import { useFavoriteProducts } from "@/api/hooks";
import { useRequireAuth } from "@/features/auth-gate";
import { useFavoriteRows } from "./use-favorite-rows";

/** Şeritte gösterilecek favori sayısı — sepet sayfası bir vitrin değil, hatırlatma. */
const STRIP_LIMIT = 12;

/**
 * Sepet sayfasındaki yatay favori şeridi.
 *
 * Sayfalama yok: ilk sayfa yeter, "tümünü gör" favoriler sayfasına götürür.
 * Oturum yoksa ya da liste boşsa bölüm hiç çizilmez.
 */
export const useFavoritesStrip = () => {
  const { hasSession } = useRequireAuth();

  const { data, isLoading } = useFavoriteProducts({
    page: 1,
    limit: STRIP_LIMIT,
    enabled: hasSession,
  });

  const rows = useFavoriteRows(data?.data?.result);

  return {
    rows,
    total: data?.data?.meta?.total ?? 0,
    isLoading: hasSession && isLoading,
    /** Bölümün hiç çizilmemesi gereken hal. */
    isHidden: !hasSession || (!isLoading && rows.length === 0),
  };
};
